import { render, staticRenderFns } from "./QueryStu.vue?vue&type=template&id=0fa823cb"
import script from "./QueryStu.vue?vue&type=script&lang=js"
export * from "./QueryStu.vue?vue&type=script&lang=js"
import style0 from "./QueryStu.vue?vue&type=style&index=0&id=0fa823cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports